import { Component } from "react";
import { Provider } from "react-redux";
import { Router, browserHistory } from "react-router";
import { syncHistoryWithStore } from "react-router-redux";
import { transitions, positions, Provider as AlertProvider } from "react-alert";
import AlertTemplate from "react-alert-template-basic";

import getRoutes from "../routes";

const options = {
  // you can also just use 'bottom center'
  position: positions.BOTTOM_RIGHT,
  timeout: 5000,
  offset: "30px",
  // you can also just use 'scale'
  transition: transitions.SCALE,
};

export default class Root extends Component {
  render() {
    const { store } = this.props;
    const history = syncHistoryWithStore(browserHistory, store);
    return (
      <Provider store={store}>
        <AlertProvider template={AlertTemplate} {...options}>
          <div
            className="body-height"
            id="AppContainer"
            style={{ display: "flex" }}
          >
            <Router history={history}>{getRoutes(store)}</Router>
          </div>
        </AlertProvider>
      </Provider>
    );
  }
}
